"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotExtendedToM365Error = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../common/localizeUtils");
const constants_1 = require("./constants");
class NotExtendedToM365Error extends teamsfx_api_1.UserError {
    constructor(source) {
        super({
            source: source,
            name: "NotExtendedToM365Error",
            message: (0, localizeUtils_1.getDefaultString)("error.m365.NotExtendedToM365Error"),
            displayMessage: (0, localizeUtils_1.getLocalizedString)("error.m365.NotExtendedToM365Error"),
            helpLink: constants_1.M365HelpLink,
        });
    }
}
exports.NotExtendedToM365Error = NotExtendedToM365Error;
//# sourceMappingURL=errors.js.map